import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, watch } from 'vue';
import CInput from '@/components/shared/CInput';
import CButton from '@/components/shared/CButton';
import {
    type PatternConfig,
    type PatternElement,
    PATTERN_DEFAULTS
} from '@/typings/customilyElements/patternElements';


export default /*#__PURE__*/_defineComponent({
  __name: 'PatternProperties',
  props: {
    element: null,
    pattern: { type: Boolean },
    createText: { default: 'Create Pattern from Element' }
  },
  emits: ["create-pattern", "pattern-config-change", "refresh-fill", "remove-pattern"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'create-pattern'): void;
    (e: 'pattern-config-change', partial: Partial<PatternConfig>): void;
    (e: 'refresh-fill'): void;
    (e: 'remove-pattern'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { element?: PatternElement, pattern?: boolean, createText: string };





const isPattern = computed(() => !!props.pattern);

const model = reactive({
    spacingX: PATTERN_DEFAULTS.spacingX * 100,
    spacingY: PATTERN_DEFAULTS.spacingY * 100,
    offsetX: PATTERN_DEFAULTS.offsetX * 100,
    offsetY: PATTERN_DEFAULTS.offsetY * 100
});

const toPercent = (fraction: number | undefined) => Math.round((fraction ?? 0) * 100);

const initModel = (element?: PatternElement) => {
    const config = element?.patternConfig || PATTERN_DEFAULTS;
    model.spacingX = toPercent(config.spacingX);
    model.spacingY = toPercent(config.spacingY);
    model.offsetX = toPercent(config.offsetX);
    model.offsetY = toPercent(config.offsetY);
};

watch(
    () => props.element,
    (element) => initModel(element),
    { immediate: true }
);
watch(
    () => props.pattern,
    () => initModel(props.element)
);

const onConfigInput = (key: keyof PatternConfig, value: unknown) => {
    const percent = Number(value);
    if (Number.isNaN(percent)) return;
    (model as Record<string, number>)[key] = percent;
    emit('pattern-config-change', { [key]: percent / 100 } as Partial<PatternConfig>);
};

return { __sfc: true,props, emit, isPattern, model, toPercent, initModel, onConfigInput, CInput, CButton }
}

})